<template>
  <div>
    <b-modal
      v-model="cropperModal"
      centered
      :title="modalTitle"
      footer-class="removed"
      class="edit-modal"
      cancel-variant="outline-secondary"
      size="lg"
      no-close-on-backdrop
    >
      <div class="cropper-container">
        <cropper
          ref="cropper"
          :src="image.src"
          :stencil-props="{
            aspectRatio: aspectRatio,
          }"
        />

        <hr />

        <b-button variant="success" @click="onConfirmCrop()"> تأكيد </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import "vue-advanced-cropper/dist/style.css";
import { Cropper } from "vue-advanced-cropper";
import { BButton, BModal } from "bootstrap-vue";
import { getMimeType } from "@/utils/utils";

export default {
  components: {
    Cropper,
    BButton,
    BModal,
  },
  props: {
    modalTitle: {
      type: String,
      default: () => "قص الصورة ...",
    },
    aspectRatio: {
      type: Number,
      default: () => 1 / 1,
    },
    value: Boolean,
  },
  data() {
    return {
      image: {
        src: null,
        type: null,
      },
      cropperModal: false,
    };
  },

  methods: {
    onConfirmCrop() {
      const { canvas } = this.$refs.cropper.getResult();
      canvas.toBlob(async (blob) => {
        this.$emit("confirm", blob);
      });

      this.cropperModal = false;
    },
    reset() {
      this.image = {
        src: null,
        type: null,
      };
    },
    loadImage(event) {
      const { files } = event.target;
      if (files && files[0]) {
        if (this.image.src) {
          URL.revokeObjectURL(this.image.src);
        }
        const blob = URL.createObjectURL(files[0]);
        const reader = new FileReader();
        reader.onload = (e) => {
          this.image = {
            src: blob,
            type: getMimeType(e.target.result, files[0].type),
          };
        };
        reader.readAsArrayBuffer(files[0]);
      }

      this.cropperModal = true;
    },
  },
  destroyed() {
    if (this.image.src) {
      URL.revokeObjectURL(this.image.src);
    }
  },
};
</script>

<style lang="scss">
[dir] .vue-bounding-box__handler {
  direction: rtl !important;
}
[dir] .cropper-container {
  .vue-advanced-cropper {
    direction: ltr;
  }
  * {
    direction: ltr;
  }
}
[dir="rtl"] .vue-handler-wrapper--east-south {
  cursor: se-resize;
}
[dir="rtl"] .vue-handler-wrapper--west-south {
  cursor: sw-resize;
}
[dir="rtl"] .vue-handler-wrapper--west-north {
  cursor: nw-resize;
}
[dir="rtl"] .vue-handler-wrapper--east-north {
  cursor: ne-resize;
}
.uploading {
  opacity: 0.8 !important;
}
.camera-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0;
  transition: all 0.3s ease;
  cursor: pointer;
  user-select: none;
  &:active {
    background-color: gray;
  }
  &:hover {
    opacity: 0.8;
  }
  z-index: 1;
}
.camera-icon {
  position: absolute;
  left: 35%;
  top: 35%;
}
</style>
